<template>
  <div
    class="modal fade snappy-green-modal"
    :id="modalId"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    @click.self="$emit('close')"
  >
    <div class="modal-dialog modal-dialog-centered snappy-green-modal__dialog" role="document">
      <div class="modal-content snappy-green-modal__content">
        <div class="modal-header snappy-green-modal__header">
          <slot name="header" />
          <button type="button" class="close snappy-green-modal__close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body snappy-green-modal__body">
          <slot />
        </div>
        <div class="modal-footer snappy-green-modal__footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'snappy-green-modal',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    modalId() {
      return Math.random().toString(36).slice(2);
    },
  },
  watch: {
    open: {
      immediate: true,
      handler(shown) {
        $(`#${this.modalId}`).modal(shown ? 'show' : 'hide');
      },
    },
  },
  mounted() {
    $(`#${this.modalId}`).on('hide.bs.modal', () => this.$emit('close-modal'));
  },
};
</script>

<style lang="scss" scoped>
@import '../../sass/web/_variables.scss';

.snappy-green-modal {
  padding-left: 0 !important;
  &__dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  &__content {
    width: 509px;
    border: none;
    overflow: hidden;
    border-radius: 3px;
  }
  &__close {
    position: absolute;
    background: transparent;
    color: #c0c1c2;
    font-size: 24px;
    font-weight: normal;
    opacity: 1;
    text-shadow: none;
  }
  &__header {
    background: #399999;
    font-size: 19px;
    border-bottom: 0;
    color: $white-color;
    padding: 21px 24px;
  }
  &__body,
  &__footer {
    padding: 24px;
  }
}
</style>
